import {
  RenderApprover,
  RenderCreateFormButton,
  RenderHelper,
  RenderUnit,
} from "../../../summary-employee-request/utils/render-helper";
import { Box } from "../../../../../../components";
import { formFields1, formFields2 } from "../../constant/field-names";
import { Form, Row } from "antd";
import { useState } from "react";
import { PATH } from "../../constant/path";
import { useHistory } from "react-router-dom";
import { CreateNotification } from "../../../../../../components/notifier";

export function CreateForm() {
  const [form] = Form.useForm();
  const [department, setDepartment] = useState("");

  const onValuesChange = (changedValues: any, allValues: any) => {
    if (changedValues.eDepartment) {
      setDepartment(changedValues.eDepartment);
    }
  };

  const history = useHistory();

  const onFinish = (values: any) => {
    history.push(PATH.HOME);
    CreateNotification({
      title: "Thành công",
      body: "Tạo yêu cầu thành công",
      icon: "/icons/success.png",
    });
  };

  return (
    <>
      <Form
        size="large"
        onFinish={onFinish}
        form={form}
        onValuesChange={onValuesChange}
      >
        <Box title="Thông tin">
          <Row gutter={[32, 0]}>
            <RenderHelper fields={formFields1} />
            <RenderUnit department={department} form={form} span={8} />
          </Row>
        </Box>

        <Box title="Thông tin chi tiết">
          <Row gutter={[32, 0]}>
            <RenderHelper fields={formFields2} />
            <RenderApprover department={department} form={form} />
            <RenderCreateFormButton homePath={PATH.HOME} />
          </Row>
        </Box>
      </Form>
    </>
  );
}
